import { COLOR_PALETTE } from 'constants/ui';

export const dialerContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: '16px',
  gap: '12px',
  backgroundColor: ({ palette }) => palette.background.secondary,
  overflow: 'auto',
};

export const numberInputStyles = {
  '& .MuiOutlinedInput-root': {
    backgroundColor: ({ palette }) => palette.background.paper,
    borderRadius: '8px',
    fontSize: '20px',
    letterSpacing: '2px',
    textAlign: 'center',
    '& input': {
      textAlign: 'center',
      padding: '12px 14px',
    },
  },
};

export const numpadGridStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '8px',
  justifyItems: 'center',
};

export const numpadButtonStyles = {
  width: 64,
  height: 64,
  borderRadius: '50%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) => palette.background.paper,
  transition: 'background-color 0.15s',
  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },
  '&:active': {
    backgroundColor: ({ palette }) => palette.background.hoverDefault,
  },
};

export const numpadDigitStyles = {
  fontSize: '22px',
  fontWeight: 500,
  lineHeight: 1.2,
  color: ({ palette }) => palette.text.strong,
};

export const numpadLettersStyles = {
  fontSize: '9px',
  fontWeight: 400,
  letterSpacing: '2px',
  color: ({ palette }) => palette.text.placeholder,
  lineHeight: 1,
  minHeight: '10px',
};

export const callButtonStyles = {
  width: 64,
  height: 64,
  borderRadius: '50%',
  backgroundColor: COLOR_PALETTE.GREEN[7],
  color: '#fff',
  '&:hover': {
    backgroundColor: COLOR_PALETTE.GREEN[8],
  },
  '&.Mui-disabled': {
    backgroundColor: ({ palette }) => palette.background.hoverDefault,
    color: ({ palette }) => palette.text.placeholder,
  },
};

export const deleteButtonStyles = {
  width: 64,
  height: 64,
  borderRadius: '50%',
  color: ({ palette }) => palette.text.secondary,
};

export const bottomRowStyles = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '8px',
  justifyItems: 'center',
};
